import { render, staticRenderFns } from "./BusinessList.vue?vue&type=template&id=9fdee61c&scoped=true&"
import script from "./BusinessList.vue?vue&type=script&lang=js&"
export * from "./BusinessList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessList.vue?vue&type=style&index=0&id=9fdee61c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdee61c",
  null
  
)

export default component.exports